import get from 'lodash/get';
import { useQuery } from 'react-query';

import config from 'config';

import * as Api from '../api';
import * as Constants from '../constants';
import * as Mappers from '../mappers';

const useList = ({ params }) => {
  const initialData = { items: [], meta: Mappers.Meta() };

  const paramsWithDefaults = {
    page: params?.page ? params.page : 1,
    perPage: params?.perPage || config.perPage,
    searchText: params?.searchText || '',
  };

  const { data = initialData, ...args } = useQuery(
    [Constants.ENTITY, 'list', paramsWithDefaults],
    async () => {
      const { data } = await Api.List({
        params: paramsWithDefaults
      });      

      const items = (get(get(data, 'data'), 'chunks') || []).map(item => Mappers.AiSearch(item));

      const meta = Mappers.Meta(data.data);

      return { items, meta };
    },
    { initialData, keepPreviousData: true }
  );

  return { ...data, ...args };
};

export default useList;
